import { useIntegrations } from "@/features/integrations/hooks/useIntegrations";
import { useAuth } from "@/lib/hooks/useAuth";
import { usePermissionMatrix } from "@/lib/hooks/usePermissionMatrix";

export function useCaptainEnabled() {
  const { canView } = usePermissionMatrix();
  const { tenantId } = useAuth();

  const { data: integrations } = useIntegrations({
    tenantId,
    includes: ["modules"],
  });

  if (!canView("captain")) return false;

  const captain = integrations?.find((i) => i.name === "captain");
  if (!captain?.isActive) return false;

  const chatModule = captain.modules.find((m) => m.moduleName === "chat");
  return chatModule?.isActive === true;
}
